import React from "react";
import { isAuthenticated } from "../auth";
import useShippingEstimate, { buildEstimateItems, buildEstimateDestination } from "./shippingEstimate/useShippingEstimate";
import { ShippingCostValue, businessDaysText, deliveryTypeText } from "./shippingEstimate/ShippingEstimateSummary";
import { elakayAutoText } from "./dataElakay";

// Per-item shipping line of a cart card. Used to be a static "Free Shipping /
// 2-14 business days" text comparing the Seller's address with the buyer's;
// it now shows the backend estimate for THIS item (real shipper origin, the
// buyer's delivery address, the selected variant and quantity).
const ShippingCart = ({ products, Saddress }) => {
  const { token } = isAuthenticated() || {};
  const estimate = useShippingEstimate({
    items: buildEstimateItems(products ? [products] : []),
    destination: buildEstimateDestination(Saddress),
    token,
  });
  const line = estimate.status === "ready" ? estimate.data?.lines?.[0] : null;
  const destination = estimate.data?.destination;
  return (
    <div style={{ fontSize: "0.8125rem", color: "#64748b" }}>
      <div style={{ color: "#1e293b" }}>
        <ShippingCostValue estimate={estimate} />
      </div>
      {line?.delivery?.available && (
        <div>
          {deliveryTypeText(line.deliveryType)}
          <br />
          {elakayAutoText("h_shipest_estimated_delivery", "Estimated delivery")}: {businessDaysText(line.delivery.minBusinessDays, line.delivery.maxBusinessDays)}
        </div>
      )}
      {line && destination?.status !== "resolved" && (
        <div>{elakayAutoText("h_shipest_select_address", "Select a delivery address to estimate shipping.")}</div>
      )}
    </div>
  );
};

export default ShippingCart;
